/* 3D App Studio route tree (module: appStudio) — mounted from src/App.js:
 * <Route path="3dapp-studio/*" element={<AppStudioRoutes />} />
 * Under app/:appId: flat, deep-linkable page routes behind ONE sidebar.
 * The legacy walkthrough/build paths redirect to overview. */
import React from 'react';
import {
    Navigate,
    Route,
    Routes
} from 'react-router-dom';
import AppStudioShell from './AppStudioShell';
import AppsList from './screens/AppsList';
import StudioAgentDock from '../destudio/agent/StudioAgentDock';
import AppJsonPage from './screens/AppJsonPage';
import OverviewPage from './screens/OverviewPage';
import SourcesPage from './screens/sources/SourcesPage';
import WorkflowsPage from './screens/workflows/WorkflowsPage';
import JourneysPage from './screens/journeys/JourneysPage';
import IdentityPage from './screens/identity/IdentityPage';
import RunsPage from './screens/runs/RunsPage';
import WorkflowRunsPage from './screens/runs/WorkflowRunsPage';

export default function AppStudioRoutes() {
    return (
        <>
            <Routes>
                <Route index element={<AppsList />} />
                <Route path="app/:appId" element={<AppStudioShell />}>
                    <Route index element={<Navigate to="overview" replace />} />
                    <Route path="overview" element={<OverviewPage />} />
                    <Route path="json" element={<AppJsonPage />} />
                    <Route path="learn" element={<Navigate to="../overview" replace />} />
                    <Route path="sources" element={<SourcesPage />} />
                    <Route path="workflows" element={<WorkflowsPage />} />
                    <Route path="journeys" element={<JourneysPage />} />
                    <Route path="identity" element={<IdentityPage />} />
                    <Route path="runs" element={<RunsPage />} />
                    <Route path="workflow-runs" element={<WorkflowRunsPage />} />
                    <Route path="build" element={<Navigate to="../overview" replace />} />
                    <Route path="walkthrough" element={<Navigate to="../overview" replace />} />
                    <Route path="walkthrough/*" element={<Navigate to="../overview" replace />} />
                    <Route path="*" element={<Navigate to="overview" replace />} />
                </Route>
                <Route path="*" element={<Navigate to="." replace />} />
            </Routes>
            <StudioAgentDock />
        </>
    );
}
